import React from 'react';
import cn from 'classnames';
import TimelineStep from './timeline-step';
import {
  TimelineCnt,
  StyledStepper,
  StyledStepConnector,
  TimelineCard,
  TimelineCardDesktop
} from './styles';

const Timeline = props => {
  const {
    isMobile,
    account,
    delivery,
    shipment,
    handleClick,
    handleHover
  } = props;

  return (
    <TimelineCnt
      elevation={0}
      className={cn(isMobile ? 'timelineCard' : 'timelineCardDesktop')}
    >
      {isMobile ? (
        <TimelineCard>
          <StyledStepper
            orientation="vertical"
            connector={<StyledStepConnector />}
          >
            {delivery.map((step, index) => (
              <TimelineStep
                shipment={shipment}
                state={step}
                index={index}
                states={delivery}
                account={account}
                key={step.id}
                handleClick={handleClick}
                handleHover={handleHover}
              />
            ))}
          </StyledStepper>
        </TimelineCard>
      ) : (
        <TimelineCardDesktop>
          <StyledStepper
            orientation="vertical"
            connector={<StyledStepConnector />}
          >
            {delivery.map((step, index) => (
              <TimelineStep
                shipment={shipment}
                state={step}
                index={index}
                states={delivery}
                account={account}
                key={step.id}
                handleClick={handleClick}
                handleHover={handleHover}
              />
            ))}
          </StyledStepper>
        </TimelineCardDesktop>
      )}
    </TimelineCnt>
  );
};

export default Timeline;
